var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInProcess = function SvgInProcess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.276 0.705201L11.0013 0.626709L10.7266 0.705201L1.39325 3.37187L0.667969 3.57909V4.33339C0.667969 6.55298 1.15246 10.2911 2.61525 13.7101C4.07496 17.1219 6.60302 20.4136 10.7918 21.3112L11.0013 21.3561L11.2108 21.3112C15.3996 20.4136 17.9276 17.1219 19.3874 13.7101C20.8501 10.2911 21.3346 6.55298 21.3346 4.33339V3.57909L20.6094 3.37187L11.276 0.705201ZM4.45402 12.9234C3.27115 10.1586 2.78341 7.13068 2.68658 5.08238L11.0013 2.70674L19.316 5.08238C19.2192 7.13068 18.7315 10.1586 17.5486 12.9234C16.2371 15.9888 14.1611 18.5414 11.0013 19.3077C7.84146 18.5414 5.76554 15.9888 4.45402 12.9234ZM8.33463 9.66673H5.66797V12.3334H8.33463V9.66673ZM12.3346 9.66673V12.3334H9.66797V9.66673H12.3346ZM16.3346 9.66673H13.668V12.3334H16.3346V9.66673Z",
    fill: "#8D97A4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInProcess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "in-process.4593234f7f7dd15187d36bf7def27ca1.svg";